import AboutTheHukosWrapper from '@/layouts/AboutTheHukosWrapper'

import PageNotFound from '@/pages/PageNotFound'

const AboutTheHukos = () => import('@/pages/AboutTheHukos')
const Appearance = () => import('@/pages/about-the-hukos/Appearance')
const Magic = () => import('@/pages/about-the-hukos/Magic')
const Shifting = () => import('@/pages/about-the-hukos/magic/Shifting')
const Kumo = () => import('@/pages/about-the-hukos/magic/Kumo')
const Incubation = () => import('@/pages/about-the-hukos/magic/Incubation')
const Storing = () => import('@/pages/about-the-hukos/magic/Storing')
const LifeCycle = () => import('@/pages/about-the-hukos/LifeCycle')
const Family = () => import('@/pages/about-the-hukos/Family')
const Religion = () => import('@/pages/about-the-hukos/Religion')
const Evolution = () => import('@/pages/about-the-hukos/Evolution')

const childrenRoutes = [
	{
		path     : '/',
		name     : 'About the Hukos',
		component: AboutTheHukos,
		meta     : { root: true }
	},
	{
		path     : 'appearance',
		name     : 'Appearance',
		component: Appearance
	},
	{
		path     : 'magic',
		name     : 'Magic',
		component: Magic
	},
	{
		path     : 'magic/shifting',
		name     : 'Shifting',
		component: Shifting,
		meta     : { parent: 'magic' }
	},
	{
		path     : 'magic/kumo',
		name     : 'Kumo',
		component: Kumo,
		meta     : { parent: 'magic' }
	},
	{
		path     : 'magic/incubation',
		name     : 'Incubation',
		component: Incubation,
		meta     : { parent: 'magic' }
	},
	{
		path     : 'magic/storing',
		name     : 'Storing Lafo',
		component: Storing,
		meta     : { parent: 'magic' }
	},
	{
		path     : 'life-cycle',
		name     : 'Life Cycle',
		component: LifeCycle
	},
	{
		path     : 'family',
		name     : 'Family',
		component: Family
	},
	{
		path     : 'religion',
		name     : 'Religion',
		component: Religion
	},
	{
		path     : 'evolution',
		name     : 'Evolution',
		component: Evolution
	}
]

childrenRoutes.forEach(route => {
	if (route.meta === undefined) route.meta = {}
	route.meta.area = 'about-the-hukos'
})

childrenRoutes.push({ path: '*', component: PageNotFound })

export default {
	path     : '/about-the-hukos',
	component: AboutTheHukosWrapper,
	children : childrenRoutes
}
